import { access2off, access3off, access4off, access2on, access3on, access4on, accessBanner, IconAlarm } from '@assets/images/main/index';

import { BlueIconPhone, BlueIconRFID, BlueIconRemote, BlueIconWatch, BlueIconWidget } from '@assets/images/icon/blue';
import {
  AdvantageImgD,
  AdvantageImgM,
  AdvantageImgT,
  Falldown1D,
  Falldown1M,
  Falldown1T,
  Falldown2D,
  Falldown2M,
  Falldown2T,
  Falldown3D,
  Falldown3M,
  Falldown3T,
  installationImg1D,
  installationImg1M,
  installationImg1T,
  installationImg2D,
  installationImg2M,
  installationImg2T,
  installationImg3D,
  installationImg3M,
  installationImg3T,
  installationImg4D,
  installationImg4M,
  installationImg4T,
  installationImg5D,
  installationImg5M,
  installationImg5T,
  hardwareImg1D,
  hardwareImg1M,
  hardwareImg1T,
  hardwareImg2D,
  hardwareImg2M,
  hardwareImg2T,
  hardwareImg3D,
  hardwareImg3M,
  hardwareImg3T,
  hardwareImg4D,
  hardwareImg4M,
  hardwareImg4T,
  hardwareImg5D,
  hardwareImg5M,
  hardwareImg5T,
  accessBannerBg,
  accessBannerProduct,
} from '@assets/images/main/access/components/index';
import { IconAccessLiteOff, IconAccessLiteOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueCircle, IconBlueCycle, IconBlueDevelop, IconBlueFigure, IconBluePower, IconBlueScan, IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3dCheck, Icon3dSchedule, IconLocation } from '@assets/images/icon';

export default {
  banner: {
    title: 'Ra vào tự nhiên,<br/>ghi chép tự động.',
    desc: 'Cửa sẽ tự động mở khi mang thẻ hoặc thiết bị di động đến gần,<br/>mọi lịch sử ra vào được lưu ngay trên hệ thống ORBRO OS theo thời gian thực.',
    productImg: accessBannerProduct,
    bgImg: accessBannerBg,
    schemeTitle: 'Hãy chọn hệ thống kiểm soát ra vào dành cho bạn',
    schemeDesc: 'Cần hỗ trợ để quyết định? ',
    schemeDesc2: 'Hãy liên hệ với<br/>chúng tôi, chuyên gia sẽ hỗ trợ bạn.',
    phone: '1522-9928',
  },

  mainPage: {
    product: {
      title: 'Khám phá cấu hình sản phẩm',
      desc: 'Khám phá cấu hình hệ thống kiểm soát ra vào đột phá.',

      auto: {
        title: 'Ra vào cửa tự động',
        desc: 'Khởi đầu hệ thống dành riêng cho cửa tự động<br/>Tương thích mọi loại cửa',
      },
      face: {
        title: 'Ra vào bằng nhận diện khuôn mặt',
        desc: 'Nhận diện khuôn mặt, ra vào di động, thẻ NFC…<br/>Hỗ trợ mọi phương thức',
      },
      accessory: {
        title: 'Phụ kiện kiểm soát ra vào',
        desc: 'Tìm hiểu tất cả sản phẩm<br/>liên quan đến hệ thống ra vào',
      },
    },
  },

  FAQ: [
    {
      title: 'Orbro Access nhận diện ra vào bằng cách nào?',
      description:
        'Tùy thuộc vào sản phẩm, hệ thống hỗ trợ nhiều phương thức xác thực khác nhau như BLE (Bluetooth), NFC, nhận diện khuôn mặt AI, v.v., trong đó phương thức cơ bản nhất là ra vào dựa trên vị trí thông qua ứng dụng di động.',
    },
    {
      title: 'Có thể ra vào ngay cả khi không có Smartphone không?',
      description: 'Vâng có thể. Nếu sử dụng Orbro Access Key là thẻ chuyên dụng, có thể xác thực ra vào ngay cả khi không có Smartphone.',
    },
    {
      title: 'Có thể sử dụng ngay cả trong không gian không có cửa tự động không?',
      description:
        'Vâng. Ngay cả khi không có cửa tự động, nếu liên kết với EM Lock hoặc Deadbolt, thiết bị đầu cuối Orbro Access có thể điều khiển thiết bị khóa để kiểm soát việc ra vào.',
    },
    {
      title: 'Lịch sử ra vào được lưu trữ như thế nào?',
      description:
        'Tất cả các bản ghi như thời gian ra vào, thời gian lưu trú, phương tiện xác thực, v.v. được tự động lưu trữ trên ORBRO OS và có thể được kiểm tra trên màn hình quản trị.',
    },
    {
      title: 'Có thể sử dụng trong môi trường không có kết nối mạng không?',
      description:
        'Vâng, có thể. Ngay cả trong môi trường không có máy chủ, hệ thống có thể hoạt động ở chế độ ngoại tuyến (Offline Mode), nhưng lịch sử ra vào sẽ không được lưu trữ ở chế độ này.',
    },
    {
      title: 'Có thể liên kết với các hệ thống bên ngoài không?',
      description:
        'Các sản phẩm Access Lite và Access Pro hỗ trợ tích hợp API, cho phép kết nối dễ dàng với hệ thống bảo mật nội bộ hoặc giải pháp quản lý nhật ký ra vào.',
    },
    {
      title: 'Có hỗ trợ ra vào bằng nhận diện khuôn mặt không?',
      description:
        'Model Access Pro hỗ trợ ra vào bằng nhận diện khuôn mặt dựa trên AI, mang lại khả năng xác thực nhanh chóng, không cần chạm, với độ bảo mật và hiệu quả cao.',
    },
  ],

  bannerData: [
    {
      icon: access2on,
      iconInv: access2off,
      image: '',
      iconText: 'Access Auto',
      titleKey: 'Khởi đầu hệ thống ra vào chuyên biệt cho cửa tự động<br/>Tương thích mọi loại cửa',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/vi/access/auto',
    },
    {
      icon: IconAccessLiteOn,
      iconInv: IconAccessLiteOff,
      image: '',
      iconText: 'Access Lite',
      titleKey: 'Nhận diện khuôn mặt, ra vào di động, thẻ NFC…<br/>Hỗ trợ mọi phương thức',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/vi/access/lite',
    },
    {
      icon: access3on,
      iconInv: access3off,
      image: '',
      iconText: 'Access Pro',
      titleKey: 'Nhận diện khuôn mặt, ra vào di động, thẻ NFC…<br/>Hỗ trợ mọi phương thức',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/vi/access/pro',
    },
    {
      icon: access4on,
      iconInv: access4off,
      image: '',
      iconText: 'Accesories',
      titleKey: 'Khám phá tất cả sản phẩm<br/>liên quan hệ thống ra vào',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/vi/access/accessory',
    },
  ],

  falldown: {
    left: {
      title: 'Hệ thống quản lý ra vào hiện đại nhất,<br/>tích hợp phương thức ra vào vào Smartphone',
      desc: 'Từ cửa thông thường, cửa tự động đến cổng tốc độ cao, bạn có thể dễ dàng sử dụng mọi loại cửa trong đời sống hiện đại chỉ với chiếc Smartphone. Hãy trải nghiệm chuyển đổi số hiệu quả nhất qua hệ thống gắn liền với sinh hoạt hằng ngày của bạn.',

      fall: [
        {
          title: 'Ra vào bằng Smartphone',
          desc: 'Hỗ trợ ra vào thông qua tất cả các Smartphone chạy iOS/Android.',
          img: {
            desktop: Falldown1D,
            tablet: Falldown1T,
            mobile: Falldown1M,
          },
        },
        {
          title: 'Ra vào bằng Smart Watch',
          desc: 'Mang đến trải nghiệm ra vào thuận tiện hơn thông qua smart watch.',
          img: {
            desktop: Falldown2D,
            tablet: Falldown2T,
            mobile: Falldown2M,
          },
        },
        {
          title: 'Ra vào bằng thẻ RFID',
          desc: 'Có thể ra vào bằng cách tận dụng thẻ nhân viên (ID) hiện có.',
          img: {
            desktop: Falldown3D,
            tablet: Falldown3T,
            mobile: Falldown3M,
          },
        },
      ],
    },

    rightImg: '',
  },

  functions: {
    title: 'Phần cứng là cốt lõi,<br/>đổi mới mọi thứ, nhẹ nhàng mà hiệu quả.',
    desc: '',
    line: 2,
    card: [
      {
        img: {
          desktop: hardwareImg1D,
          tablet: hardwareImg1T,
          mobile: hardwareImg1M,
        },
        tag: 'Đèn LED trạng thái',
        title: 'NFC/Bluetooth<br/>Kiểm soát ra vào với cơ chế kênh đôi',
        desc: 'Hỗ trợ ra vào bằng thẻ NFC,<br/>cũng như qua điện thoại Smart Phone và Smart Watch.',
        size: '3',
      },
      {
        img: {
          desktop: hardwareImg2D,
          tablet: hardwareImg2T,
          mobile: hardwareImg2M,
        },
        tag: 'Nguồn cấp',
        title: 'Sử dụng PoE,<br/>tích hợp cả nguồn và kết nối mạn',
        size: '1',
      },
      {
        img: {
          desktop: hardwareImg3D,
          tablet: hardwareImg3T,
          mobile: hardwareImg3M,
        },
        tag: 'Lắp đặt dễ dàng',
        title: 'Lắp đặt nhanh chóng với<br/>giá đỡ chuyên dụng',
        size: '2',
      },
      {
        img: {
          desktop: hardwareImg4D,
          tablet: hardwareImg4T,
          mobile: hardwareImg4M,
        },
        tag: 'Loa tích hợp tích hợp',
        title: 'Thông báo ra/vào<br/>thông qua loa',
        size: '2',
      },
      {
        color: '#000',
        img: {
          desktop: hardwareImg5D,
          tablet: hardwareImg5T,
          mobile: hardwareImg5M,
        },
        tag: 'Đèn LED trạng thái',
        darkTitle: 'Dễ dàng kiểm tra trạng thái ngay cả khi trong ',
        lightTitle: 'đêm tối ',
        darkTitle2: '',
        desc: 'Thông qua đèn RGB LED,<br/>có thể xác nhận trạng thái thiết bị và hoạt động ra/vào.',
        size: '2',
      },
    ],
  },

  installation: {
    title: 'Lắp đặt sản phẩm? Đừng lo<br/>Chúng tôi sẽ làm hết mọi thứ cho bạn.',
    card: [
      {
        img: {
          desktop: installationImg1D,
          tablet: installationImg1T,
          mobile: installationImg1M,
        },
        tag: 'Cung cấp On-premise Server',
        title: 'Máy chủ cấp doanh nghiệp<br/>chất lượng cao',
      },
      {
        img: {
          desktop: installationImg2D,
          tablet: installationImg2T,
          mobile: installationImg2M,
        },
        tag: 'Hỗ trợ lắp đặt tại chỗ bởi chuyên gia',
        title: 'Liên hệ 1522-9928<br/>đê được lắp đặt sớm nhất',
        desc: 'Giờ làm việc: các ngày trong tuần (9:00 - 18:00)',
      },
      {
        img: {
          desktop: installationImg3D,
          tablet: installationImg3T,
          mobile: installationImg3M,
        },
        tag: 'Phụ kiện kiểm soát ra vào',
        title: 'Hỗ trợ lắp đặt Deadbolt',
      },
      {
        img: {
          desktop: installationImg4D,
          tablet: installationImg4T,
          mobile: installationImg4M,
        },
        tag: 'Phụ kiện kiểm soát ra vào',
        title: 'Hỗ trợ lắp đặt EM Lock',
      },
      {
        theme: 'black',
        img: {
          desktop: installationImg5D,
          tablet: installationImg5T,
          mobile: installationImg5M,
        },
        tag: 'Phụ kiện kiểm soát ra vào',
        title: 'Hỗ trợ lắp đặt Electric Strike',
      },
    ],
  },

  advantage: {
    img: {
      desktop: AdvantageImgD,
      tablet: AdvantageImgT,
      mobile: AdvantageImgM,
    },
    title: 'ORBRO<br/>khác gì so với hệ thống kiểm soát ra vào hiện có',
    desc: 'Đây là thiết bị ra vào hiện đại nhất, cung cấp nhiều phương thức ra vào đang thay đổi trong xã hội hiện đại chỉ trong một thiết bị duy nhất. ORBRO quản lý việc ra vào từ các phương thức truyền thống cho đến những công nghệ thông minh mới nhất, mang đến môi trường ra vào thuận tiện và an toàn cho người dùng.',
    card: [
      {
        icon: BlueIconPhone,
        title: 'Ra vào bằng Smartphone',
        desc: 'Có thể điều khiển cửa ra vào thông qua ứng dụng iOS / Android.',
      },
      {
        icon: BlueIconWidget,
        title: 'Hỗ trợ widget',
        desc: 'Tiện ích giúp sử dụng ứng dụng di động một cách thuận tiện hơn.',
      },
      {
        icon: BlueIconWatch,
        title: 'Ra vào bằng Smart Watch',
        desc: 'Trải nghiệm phương thức ra vào tiện lợi qua Smart Watch.',
      },
      {
        icon: BlueIconRemote,
        title: 'Điều khiển từ xa',
        desc: 'Quản trị viên có thể quản lý cửa ra vào từ xa.',
      },
      {
        icon: BlueIconRFID,
        title: 'Thẻ RFID & NFC',
        desc: 'Chỉ cần chạm thẻ RFID hoặc NFC Tag để điều khiển cửa ra vào một cách đơn giản.',
      },
    ],
  },

  func: {
    title: 'Tìm hiểu thêm về tính năng',

    data: [
      {
        img: IconBlueShield,
        title: 'Phương thức xác thực ra vào',
        desc: 'Cung cấp nhiều phương thức xác thực ra vào đa dạng như BLE (Bluetooth), NFC, nhận diện khuôn mặt AI, v.v. Tính năng khác nhau tùy thuộc vào sản phẩm, và có thể lựa chọn phương thức phù hợp với môi trường.',
      },
      {
        img: IconBlueScan,
        title: 'Ra vào tự động bằng thiết bị di động',
        desc: 'Người dùng cài đặt ứng dụng chuyên dụng chỉ cần mang theo Smartphone và tiến đến cửa ra vào, hệ thống sẽ tự động xác thực và mở cửa mà không cần thao tác thêm.',
      },
      {
        img: IconBlueFigure,
        title: 'Ra vào không tiếp xúc bằng thẻ',
        desc: 'Trong trường hợp sử dụng thẻ Access Key Tag, có thể xác thực ngay cả khi không có smartphone. Chỉ cần mang theo thẻ, cửa ra vào sẽ được điều khiển tự động.',
      },
      {
        img: IconBlueCircle,
        title: 'Quản lý quyền ra vào',
        desc: 'Có thể thiết lập quyền ra vào theo người dùng, theo khu vực và hạn chế việc ra vào theo cấp độ bảo mật.',
      },
      {
        img: Icon3dSchedule,
        title: 'Lưu trữ tự động lịch sử ra vào',
        desc: 'Thời gian ra vào, thời gian lưu trú, phương thức xác thực, v.v. được lưu trữ trên ORBRO OS theo thời gian thực. Dữ liệu có thể được kiểm tra theo ngày/theo người dùng trên trang quản trị.',
      },
      {
        img: IconBluePower,
        title: 'Hỗ trợ môi trường không Internet',
        desc: 'Chế độ ngoại tuyến cho phép xác thực ra vào độc lập. Hệ thống vận hành linh hoạt ngay cả trong môi trường thiếu hạ tầng mạng.',
      },
      {
        img: Icon3dCheck,
        title: 'Hỗ trợ liên kết cửa tự động hoặc ra vào độc lập',
        desc: 'Ở những nơi không có cửa tự động, hệ thống có thể liên kết với các thiết bị khóa như EM Lock, Deadbolt và các thiết bị khóa khác để tự động mở cửa sau khi xác thực.',
      },
      {
        img: IconBlueDevelop,
        title: 'Liên kết bên ngoài dựa trên API',
        desc: 'Các model Access Lite, Access Pro hỗ trợ liên kết API, cho phép kết nối với các hệ thống bảo mật khác, hệ thống chấm công, hệ thống đặt chỗ cơ sở khác.',
      },
    ],
  },
};
